/**
 * Labstep
 *
 * @module core/Label/Remove
 * @desc Tag label
 */

import classnames from 'classnames';
import { Icon } from 'labstep-web/core/Icon';
import type React from 'react';
import { Label } from 'semantic-ui-react';
import styles from './styles.module.scss';
import type {
  ICoreRemoveLabelProps,
  IRemoveLabelProps,
} from './types';

export const CoreRemoveLabel: React.FC<ICoreRemoveLabelProps> = ({
  name,
  onNameClick,
  icon,
  remove,
  className,
  cornerIcon,
  action,
}) => (
  <Label size="large" circular>
    <span
      data-cy="core/Label/Remove"
      data-testid="label-remove"
      onClick={onNameClick}
      className={classnames(styles.label, className, {
        [styles.clickable]: onNameClick,
      })}
    >
      {icon && (
        <span style={{ marginRight: 2 }}>
          <Icon name={icon} cornerIcon={cornerIcon} />
        </span>
      )}
      {name}
    </span>
    <span style={{ marginLeft: 9 }}>
      {action}
      {remove}
    </span>
  </Label>
);

export const RemoveLabel: RFC<IRemoveLabelProps> = ({
  onRemoveClick,
  status,
  ...rest
}) => (
  <CoreRemoveLabel
    remove={
      onRemoveClick && (
        <Icon
          disabled={(status && status.isFetching) || false}
          name="times"
          onClick={onRemoveClick}
        />
      )
    }
    {...rest}
  />
);
